import { CheckoutWorkflowEnum } from 'src/app/core/services/checkout.service';
import { CheckoutService } from '../../../core/services/checkout.service';
import { LoadingService } from '../../../core/services/loading.service';
import { ConfigHelper } from '../../../core/services/helpers/config.helper';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { ShoppingCartDto, UserOrderStatusDto } from 'src/app/core/dtos/dto';

import { first, take } from 'rxjs/operators';
import { AffiliateLinkActivityTypeEnum, BrandEnum, OrderStatusEnum, ProductTypeEnum } from 'src/app/core/dtos/enum';
import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { Step } from 'src/app/core/dtos/step';
import { PageStepEnum, StepProgressService, StepTypeEnum } from 'src/app/core/services/step-progress.service';
import { AffiliateService } from 'src/app/core/services/affiliate.service';
import { FacebookPixelService } from 'src/app/core/services/facebook-pixel.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics.service';
import { selectShoppingCart } from 'src/app/state/shopping-cart.selectors';
import { selectRegData } from 'src/app/state/reg-data.selectors';
import { RegData } from 'src/app/core/dtos/reg-data';

declare var gtag: Function;
@Component({
  selector: 'app-order-complete',
  templateUrl: './order-complete.component.html',
  styleUrls: ['./order-complete.component.scss']
})
export class OrderCompleteComponent implements OnInit, OnDestroy {

  brandId: BrandEnum;
  orderNumber: string;
  userOrderStatusDto: UserOrderStatusDto;
  steps: Step[];
  shoppingCartSubscription: Subscription;
  orderIncompleted: boolean;
  approvedStatusNumber = OrderStatusEnum.PaymentApproved;
  pendingStatusNumber = OrderStatusEnum.Pending;
  shoppingCart$: Observable<ShoppingCartDto>;
  initialShoppingCart: ShoppingCartDto;
  reg: RegData;
  regData$: Observable<RegData>;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private store: Store,
    private configHelper: ConfigHelper,
    private loadingService: LoadingService,
    private checkoutService: CheckoutService,
    private stepProgressServiceService: StepProgressService,
    private affiliateService: AffiliateService,
    private fbPixelService: FacebookPixelService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.Complete, StepTypeEnum.Checkout);
  }

  ngOnInit(): void {
    this.loadingService.forceHide();
    this.getInitialShoppingCartInfo();
    this.checkoutService.redirectCheckoutCompleteBasedOnFlow(CheckoutWorkflowEnum.RegCheckOut);
    this.brandId = this.configHelper.getBrandId();
    this.getOrderNumber();

    const facebookPixelId = "399283786078546";
    this.fbPixelService.loadPixel(facebookPixelId);
    this.googleAnalyticsService.eventEmitter("order_complete", "engagement", "Order Completed", "Order Complete Page Loaded");

  }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnDestroy(): void {
    this.shoppingCartSubscription?.unsubscribe();
  }

  getOrderNumber() {
    this.orderNumber = this.checkoutService.getLastCheckoutOrderNumber();
    if (this.orderNumber) {
      this.getOrderStatus();
    }
  }

  getOrderStatus() {
    this.loadingService.show();
    this.checkoutService.getLastOrderStatus(this.orderNumber).pipe(first())
      .subscribe(
        (result) => {
          this.userOrderStatusDto = result.content;
          if (this.userOrderStatusDto.userOrderStatus === OrderStatusEnum.Pending) {
            setTimeout(() => {
              this.checkoutService.getLastOrderStatus(this.orderNumber).pipe(first())
                .subscribe(
                  (res) => {
                    this.processResult(res.content);
                    this.userOrderStatusDto = res.content;
                  },
                  () => {
                    this.loadingService.hide();
                  });
            }, 5000);
          }
          else {
            this.processResult(result.content);
          }
        },
        () => {
          this.loadingService.hide();
        });
  }

  getInitialShoppingCartInfo() {
    this.shoppingCart$ = this.store.pipe(select(selectShoppingCart));
    this.regData$ = this.store.pipe(select(selectRegData));
    combineLatest([this.shoppingCart$, this.regData$])
      .pipe(take(1))
      .subscribe(([shoppingCart, regData]) => {
        this.initialShoppingCart = shoppingCart;
        this.reg = regData;
      });
  }

  processResult(result: UserOrderStatusDto) {
    this.shoppingCartSubscription = this.shoppingCartService.getShoppingCart()
      .subscribe(
        res => {
          this.store.dispatch(loadShoppingCart({ shoppingCart: res.content }));
        });

    this.loadingService.hide();
    if (result.userOrderStatus !== OrderStatusEnum.PaymentApproved) {
      this.orderIncompleted = true;
    }
    else
    {
      this.googleAnalyticsService.orderCompleteEventEmitter(result, this.initialShoppingCart, this.reg)
      if (this.checkoutService.getAffiliateCheckoutAvailableStatus() === 'true') {
        this.affiliateService.recordAffiliateActivty(AffiliateLinkActivityTypeEnum.Purchase, result.userAccountId, result.userOrderId).subscribe(() => {
          this.checkoutService.resetAffiliateTracking();
        });
      }
      this.fbPixelService.trackRegistrationComplete();
      this.trackOrderComplete();
    }
  }

  trackOrderComplete() {
    gtag('event', 'purchase', {
      'transaction_id': this.orderNumber,
      'value': this.userOrderStatusDto.total,
      'currency': this.userOrderStatusDto.currencyCode,
      'shipping': this.userOrderStatusDto.shippingAndHandling,
      'tax': this.userOrderStatusDto.tax
    });
  }


}
